<template>
    <div :class="['hpSpeakerInfo',
        actText==true ? 'spAct':'',
        speakerIndex>-1 ? 'spOpen':'']">        
        <!-- Nav -->
        <div @click="closeInfo" class="closebtn"></div>  
        
        <a v-if="showMode!='guest'" class="navBtn right" @click="showNext"><i class="fal fa-chevron-right pl-s" ></i></a>
        <a v-if="showMode!='guest'" class="navBtn left" @click="showPre"><i class="fal fa-chevron-left pl-s" ></i></a>

        <!-- Info Grid -->
        <div class="speaker_grid">
          <div :class="['speaker_img',showImg==true ? 'shown':'']">
            <!-- add image here -->
          </div>
          <div :class="['speaker_content',hiddenText==true ?'hidden':'']">
            <div class="speaker_name" id="spk_name">              
              <!-- add element here spk-split -->
            </div>
            <div class="speaker_desc fs16" id="spk_desc">
                <!-- add elements here spk-split -->
            </div>
          </div>
        </div>
    </div>
</template>

<style>
  .hpSpeakerInfo
  {
      position: fixed;
      top: 0px;left: 0px;width: 100vw;height: 100vh;
      overflow: hidden;
      background-color: #fff;
      z-index: 1002;
      display: grid;
      align-items: center;
      text-align: center;
      opacity: 1;
      clip-path: inset(0px 0px 100% 0px);
      transition: all 0.6s cubic-bezier(0.645, 0.045, 0.355, 1.000);
      pointer-events: none;
  }
  .hpSpeakerInfo.spOpen
  {
      pointer-events: all;
      opacity: 1;
      clip-path: inset(0px 0px 0px 0px);
  }
  .hpSpeakerInfo .closebtn
  {
    position: absolute;
    top: 3vh;
    right:3vh;
  }

  .speaker_grid
  {
    display: grid;
    width: 80vw;
    grid-template-columns: 400px auto;gap: 40px;
    margin: auto;        
    align-items: center;
  }
  .speaker_content.hidden
  {
    opacity: 0;
  }
  .speaker_content
  {
    width: 100%;
    clear: both;
    text-align: left;
    margin: auto;
  }
  .speaker_name div
  {
    font-size: 30px;
    letter-spacing: -1.5px !important;
    color:#202020;
    font-weight: 400 !important;
  }
  .speaker_desc .spk_split
  {
    clear: both;padding-top: 1.2vw;    
  }

  .hpSpeakerInfo .navBtn{
    position: fixed;z-index: 2000;text-align: center;width: 70px;opacity: 0.1;cursor: pointer;
  }
  .hpSpeakerInfo .navBtn i{
    font-size: 60px;color:#202020;
  }
  .hpSpeakerInfo .navBtn.right{
    top:50%;right:0px;transform: translate(-50%,-50%);   
  }
  .hpSpeakerInfo .navBtn.left{
    top:50%;left:0px;transform: translate(50%,-50%);text-align: left;  
  }

  
  /* Animations 
  animation-delay: calc(0.14s * var(--line_index)) !important;
      animation-delay:0.1s;
      animation:spk-text-up 1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
      animation-fill-mode:forwards;        

  */

  .hpSpeakerInfo .speaker_content .speaker_desc .spk-split{
    clear: both;padding-bottom: 20px;
  }
  .hpSpeakerInfo .speaker_content .speaker_desc,
  .hpSpeakerInfo .speaker_content .speaker_desc .spk-split div{
    clear: both;
    /* font-size: 16px !important; */
    /* line-height: 25px; */
    font-weight: 300 !important;
    color:#555555;
  }
  .hpSpeakerInfo .spk-textline{
    overflow: hidden;
  }
  .hpSpeakerInfo .spk-textline .spk-text{    
    opacity: 0;
  }
  .hpSpeakerInfo.spAct .spk-textline .spk-text{
      animation-delay: calc(0.1s * var(--line_index)) !important;
      animation:spk-text-up 1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
      animation-fill-mode:forwards;        
  }
  @keyframes spk-text-up {
    from {transform: translateY(40px);opacity: 0;}  
    to {transform: translateY(0);opacity: 1;}
  }

  /* ANIMATE IMG */
  .hpSpeakerInfo .speaker_img{    
    background-size: cover;
    background-position: center center;
    width: 100%;
    height: 300px;
    opacity: 0;
    transition:all 0.3s ease-in;
  }
  .hpSpeakerInfo .speaker_img.shown{
    opacity: 1;
  }
  .speaker_img img{
    width: 100%;height: auto;
  }
  



  @media (max-width:850px) {
    .speaker_grid
    {
      display: block;
      width: 100vw;
      grid-template-columns: 1fr;
      gap: 10px;
      height: 100vh;
      padding-bottom: 100px;
      overflow-x: hidden;
      overflow-y: scroll;
    }    
    .speaker_content{
      width: 100vw;
      padding: 20px 55px;
    }  
    .speaker_name{
      padding-top: 20px;
    }  
    .speaker_desc{
    }
    .hpSpeakerInfo .navBtn{
      display: none;
    }
    .speaker_desc .spk_split{
      padding-top: 20px;
    }
  }
  @media (hover: hover) {
  }    

    /* Portrait iPad mini 1, iPad 1 and iPad 2*/
    @media only screen 
    and (min-device-width: 768px) 
    and (max-device-width: 1024px) 
    and (-webkit-min-device-pixel-ratio: 1) 
    and (orientation: portrait)
    {
      .hpSpeakerInfo .speaker_img{height: 500px;}
      .speaker_name {padding-top: 50px;}      
    }

    /* Landscape iPad mini 1, iPad 1 and iPad 2 */
    @media only screen 
    and (min-device-width: 768px) 
    and (max-device-width: 1024px) 
    and (-webkit-min-device-pixel-ratio: 1) 
    and (orientation: landscape)
    {

    }  

  @media (min-width: 1800px) 
  {
    .speaker_grid    
    {
          grid-template-columns: 30vw auto !important;
    }
    .speaker_name div {
        font-size: 50px;
    }
    .hpSpeakerInfo .speaker_img {
        height: 20vw;
    }    
  }

</style>


<script>
import { mapActions, mapState } from "vuex";
import { splitLines }         from "@/utils";
import site_data from "@/site_data.json"

export default {
    name: "hpSpeakerInfo",
    props: {
        showIndex: Number,
        item_info:Object,
        showMode:String
    },
    watch: { 
        showMode: function(newVal,oldVal)
        {
            if(newVal == 'speaker'){
              //speakers
              this.speakers=site_data[1].SPEAKERS;
            }
            else if(newVal == 'com'){
              //committee
              this.speakers=site_data[1].COMMITTEE;
            }
            else if(newVal == 'guest'){
              //guest speaker
              this.speakers=site_data[1].GUEST;
            }
            else if(newVal == 'comp'){
              //competition committee
              this.speakers=site_data[1].COMPETITION.committee;
            }
        },
        showIndex: function(newVal, oldVal) 
        { 
            this.speakerIndex = newVal;
            if(newVal>-1){
                this.prepareNextItem();
            }            
        }
    },
  data()
  {
    return {
        showImg:false,
        hiddenText:true,
        actText:false,
        speakerIndex:-1,
        speakers:site_data[1].SPEAKERS,
    }
  },
  created()
  {
      //document.addEventListener('keydown', onKeydown);
  },
  destroyed()
  {
      //document.removeEventListener('keydown', onKeydown);
  },
  methods:
  {
    onKeydown(e)
    {
      alert(e.keyCode);
    },
    prepareNextItem()
    {
      var vm = this;
      //fadeout?
      //alert("preparing item");
      /*
      setTimeout(() => 
      {
        vm.initText();//split the text lines        
        vm.actText = true;//add 'spk-active' class to the root node
      }, 100);
      */  

      vm.hiddenText=true;//hide all

      let spk_img = document.getElementsByClassName('speaker_img')[0];
      let spk_name = document.getElementById('spk_name');
      let spk_desc = document.getElementById('spk_desc');
      let spk_data = this.speakers[this.speakerIndex];

      //Change image 
      //spk_img.innerHTML = "<img src='"+spk_data.img+"' />";
      //background-image: url('https://www.mis-implants.com/upload/Education/MIS-Academy/Our-Speakers/Speakers/Victor_Clavijo.jpg');
      //speaker_img

      //Add title
      spk_name.innerHTML = "<div class='spk_split'>"+spk_data.name+"</div>";     

      //Add descriotion parts
      let descriptions= '';
      for (var i = 0; i < spk_data.desc.length; i++){
        descriptions+= "<div class='spk_split'>"+spk_data.desc[i]+"</div>";     
      }
      spk_desc.innerHTML = descriptions;     

      vm.actText=false;
      vm.showImg=false;

      setTimeout(() => 
      {        
        vm.initText();
      }, 100);

      setTimeout(() => {                
        vm.animateText();
        vm.hiddenText=false;//show all
      }, 150);

      setTimeout(() => {
        if(spk_data.img.indexOf('http')>-1)
        {
          spk_img.style.backgroundImage = "url('"+spk_data.img+"')"; 
        }else{
          spk_img.style.backgroundImage = "url('img/speakers/"+spk_data.img+"')"; 
        }
        

      }, 400);

      setTimeout(() => {
        vm.showImg=true;
      }, 1000);

    },
    animateText()
    {
      this.actText=true;//will activate the 'act' class
    },
    initText()
    {      
      //Split text lines 
      var splitBlocks = document.getElementsByClassName('spk_split');
      for (var i = 0; i < splitBlocks.length; i++) 
      {
        splitLines((1+i),splitBlocks[i],'spk-textline','spk-text'); 
      }
    },
    showPre(){
      this.$emit("pre-speaker");      
    },
    showNext(){
      this.$emit("next-speaker");      
    },
    closeInfo(){
      var vm=this;
      setTimeout(() => {
          vm.actText=false;
          vm.showImg=false;
      }, 500);
      this.$emit("close-speaker");  
    },
    showSpekaer(index)
    {
        //open the requested speaker information
    }
  }



};
</script>

